import { createRequest, getEndpoint } from "../requestCreator";

export const getApiKeys = createRequest(getEndpoint("tokens.sub.get"));
export const createApiKey = createRequest(getEndpoint("tokens.sub.create"));
export const updateApiKey = createRequest(getEndpoint("tokens.sub.update"));
export const regenerateApiKey = createRequest(getEndpoint("tokens.sub.regenerate"));
export const deleteApiKey = createRequest(getEndpoint("tokens.sub.delete"));
